import React from 'react';

export function MainArea({ children }: { children?: React.ReactNode }) {
  return <>{children}</>;
}
MainArea.displayName = 'FullLayout.MainArea';
